import { render, staticRenderFns } from "./Vizitlist.vue?vue&type=template&id=04c40d6e&"
import script from "./Vizitlist.vue?vue&type=script&lang=js&"
export * from "./Vizitlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports